import { createContext, Dispatch, ReactNode, SetStateAction, useMemo, useState } from 'react';
import Questionnaire from '../models/Questionnaire';

type QuestionnaireContextType = {
  questionnaires: Questionnaire[];
  setQuestionnaires: Dispatch<SetStateAction<any>>;
  questionnaire: Questionnaire;
  setQuestionnaire: Dispatch<SetStateAction<any>>;
}

const initQuestionnaire: Questionnaire = {
  questionnaireType: '',
  createTimestamp: '',
  expirationDate: '',
  answers: [],
};

const QuestionnaireContext = createContext<QuestionnaireContextType>({
  questionnaires: [],
  setQuestionnaires: () => undefined,
  questionnaire: initQuestionnaire,
  setQuestionnaire: () => undefined,
});

export function QuestionnaireContextProvider(props: { children: ReactNode }) {
  const [questionnaires, setQuestionnaires] = useState<Questionnaire[]>([]);
  const [questionnaire, setQuestionnaire] = useState<Questionnaire>(initQuestionnaire);

  const providerValue = useMemo(() => ({
    questionnaires,
    setQuestionnaires,
    questionnaire,
    setQuestionnaire,
  }), [questionnaires, questionnaire]);

  return (
    <QuestionnaireContext.Provider value={providerValue}>
      {props.children}
    </QuestionnaireContext.Provider>
  );
}

export default QuestionnaireContext;